import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { TechnicalSupportProvidersProvider } from '../../contexts';
import { SidebarLayout } from '../../layouts';
import { PermissionsGuard } from './Components';
import { Loader } from './loader.routes';

const TechnicalSupportProviderList = Loader(
  lazy(() => import('../../content/pages/Users/TechnicalSupportProvidersList'))
);
const TechnicalSupportProviderCreate = Loader(
  lazy(() => import('../../content/pages/Users/TechnicalSupportProviderCreate'))
);

export const createTspRoutes = () => ({
  path: 'technical-support-providers',
  element: <SidebarLayout />,
  children: [
    {
      path: '',
      element: (
        <PermissionsGuard allowedPermissions={['tspViewAll']}>
          <Navigate to="/technical-support-providers/list" replace />
        </PermissionsGuard>
      )
    },
    {
      path: 'create',
      element: (
        <PermissionsGuard allowedPermissions={['tspCreate']}>
          <TechnicalSupportProvidersProvider>
            <TechnicalSupportProviderCreate />
          </TechnicalSupportProvidersProvider>
        </PermissionsGuard>
      )
    },
    {
      path: 'list',
      element: (
        <PermissionsGuard allowedPermissions={['tspViewAll']}>
          <TechnicalSupportProvidersProvider>
            <TechnicalSupportProviderList />
          </TechnicalSupportProvidersProvider>
        </PermissionsGuard>
      )
    }
  ]
});
